import React from 'react';
import { Button, Divider, Grid2, IconButton, Popover, Typography } from '@mui/material';
import { bookmarkColors } from '../constants/bookmarkColors';

export interface BookmarkColorPopoverProps {
	open: boolean;
	anchorEl: HTMLElement | null;
	onClose: () => void;
	onPickColor: (hex: string) => void;
	onClearBookmark: () => void;
}

export function BookmarkColorPopover({
	open,
	anchorEl,
	onClose,
	onPickColor,
	onClearBookmark,
}: BookmarkColorPopoverProps) {
	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			slotProps={{
				paper: {
					sx: { p: 1.5, maxWidth: 280 },
				},
			}}
		>
			<Typography variant='caption' color='text.secondary' display='block' sx={{ mb: 1 }}>
				Pick a bookmark color
			</Typography>
			<Grid2 container spacing={1}>
				{bookmarkColors.map((hex) => (
					<Grid2 key={hex} size={4}>
						<IconButton
							aria-label={`Set bookmark color ${hex}`}
							onClick={() => onPickColor(hex)}
							sx={{
								p: 0,
								width: '100%',
								aspectRatio: '1',
								borderRadius: 1,
								bgcolor: hex,
								border: '2px solid',
								borderColor: 'divider',
								'&:hover': { bgcolor: hex, opacity: 0.9 },
							}}
						/>
					</Grid2>
				))}
			</Grid2>
			<Divider sx={{ my: 1.5 }} />
			<Button fullWidth size='small' color='inherit' onClick={onClearBookmark}>
				No bookmark
			</Button>
		</Popover>
	);
}
